import { useEffect, useRef } from "react";
import { trackPageView } from "utils/analytics";

const TOTAL_STEPS = 6;

/**
 * Track page views with step information for the booking funnel.
 * Also updates the browser tab title to show progress.
 *
 * @param {string} pageTitle - The page title
 * @param {number} stepNumber - The step number in the funnel (1-6)
 * @param {string} stepName - Human readable step name
 * @param {number} stepPercentage - Progress percentage (0-100)
 */
export default function usePageView(pageTitle, stepNumber, stepName, stepPercentage) {
  const tracked = useRef(null);

  // Update browser tab title to show step progress
  useEffect(() => {
    if (!pageTitle) return;

    // Build dynamic title: "Step 2/6: Select Service"
    let dynamicTitle = pageTitle;
    if (stepNumber != null) {
      dynamicTitle = `Step ${stepNumber}/${TOTAL_STEPS}: ${pageTitle}`;
    }

    document.title = dynamicTitle;
  }, [pageTitle, stepNumber]);

  // Track analytics (separate from title updates)
  useEffect(() => {
    if (!pageTitle || tracked.current === pageTitle) return;
    tracked.current = pageTitle;

    const pageName = pageTitle.toLowerCase().replace(/[^a-z0-9]/g, "_");
    trackPageView({
      pageTitle,
      pageName,
      pagePath: window.location.pathname,
      pageUrl: window.location.href,
      stepNumber,
      stepName,
      stepPercentage,
    });
  }, [pageTitle, stepNumber, stepName, stepPercentage]);
}
